import { WindowsIcon, AppleIcon } from "@flat-ui";

/** Link to download the Windows 64-bit version of the Exporter app */
const windowsUrl =
  "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-Windows.zip";

/** Link to download the macOS Apple Silicon (ARM) version of the Exporter app */
const macArmUrl =
  "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-macOS-arm.zip";

/** Link to download the macOS Intel version of the Exporter app */
const macIntelUrl =
  "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-macOS.zip";

/** Type representing the different operating systems for the Exporter app */
export type OperatingSystem =
  /** Windows (64-bit) */
  | "windows-64bit"

  /** Mac (Apple Silicon) */
  | "mac-arm"

  /** Mac (Intel) */
  | "mac-intel";

/** Interface representing the data for each Exporter app operating system */
interface ExporterAppOSData {
  /** The operating system of the Exporter app */
  system: OperatingSystem;

  /** The download URL for the Exporter app */
  downloadUrl: string;

  /** The name of the Exporter app */
  name: string;

  /** The icon representing the operating system */
  icon: React.ReactNode;
}

/** Data for each Exporter app operating system */
export const EXPORTER_APP_OS_DATA: Record<OperatingSystem, ExporterAppOSData> =
  {
    ["windows-64bit"]: {
      system: "windows-64bit",
      downloadUrl: windowsUrl,
      name: "Windows (64-bit)",
      icon: <WindowsIcon sx={{ width: "20px", height: "20px" }} />,
    },
    ["mac-arm"]: {
      system: "mac-arm",
      downloadUrl: macArmUrl,
      name: "Mac (Apple Silicon)",
      icon: <AppleIcon sx={{ width: "20px", height: "20px" }} />,
    },
    ["mac-intel"]: {
      system: "mac-intel",
      downloadUrl: macIntelUrl,
      name: "Mac (Intel)",
      icon: <AppleIcon sx={{ width: "20px", height: "20px" }} />,
    },
  };
